import React from 'react';
import { IconSvgProps } from '@models/common';

const Heading: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.00065 3.33331V16.6666M15.0007 3.33331V16.6666M6.66732 3.33331H3.33398M15.0007 9.99998L5.00065 9.99998M6.66732 16.6666H3.33398M16.6673 16.6666H13.334M16.6673 3.33331H13.334'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Heading;
